import { red } from "@mui/material/colors";

const styles = {
  mainContainer: {
    backgroundColor: 'white', 
    borderRadius: '1rem', 
    width: '100%', 
    padding: '20px', 
    marginBottom: '12px', 
    display: 'flex', 
    gap: '10px'
  },
  searchField: {
    height: '38px', 
    borderRadius: '0.5rem', 
    flexGrow: 1,
  },
  addUserButton: {
    width: '130px', 
    borderRadius: '0.5rem', 
    height: '38px', 
    backgroundColor: red['A400']
  },
};

export default styles;